
import { defineComponent } from "vue";

import ButtonHubspot from "~/vue/atoms/buttons/ButtonHubspot.vue";
import CardUnit from "~/vue/molecules/cards/CardUnit.vue";
import GridMediaGallery from "~/vue/organisms/grids/GridMediaGallery.vue";
import LightboxFloorplan from "~/vue/organisms/lightboxes/LightboxFloorplan.vue";
import MapLocation from "~/vue/organisms/maps/MapLocation.vue";
// import PopupHubspot from '~/vue/organisms/popups/PopupHubspot.vue'
import SliderLocations from "~/vue/organisms/sliders/SliderLocations.vue";

export default defineComponent({
	components: {
		"button--hubspot": ButtonHubspot,
		"card--unit": CardUnit,
		"grid--media-gallery": GridMediaGallery,
		"lightbox--floorplan": LightboxFloorplan,
		"map--location": MapLocation,
		// 'popup--hubspot': PopupHubspot,
		"slider--locations": SliderLocations,
	},
});
